/**
 * Shared answer-normalization primitive for form-response matchers. Lives here (not in a
 * feature's `_logic`) so both `_lib` consumers (e.g. email-templates.ts) and feature consumers
 * (e.g. form-confirmation-rules.ts) can import it without a lib→feature dependency inversion.
 */

/** Unwraps the `{ value }` shape used by "Other" answers; returns the raw value otherwise. */
export const unwrapAnswer = (raw: unknown): unknown =>
  typeof raw === "object" && raw !== null ? (raw as { value?: unknown }).value : raw;
